var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"pb-3"},[_vm._v("Processamento 2D/3D em tempo")]),_c('div',{staticClass:"text-justify"},[_c('BeautifulList',{attrs:{"items":_vm.items}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }